/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetProducts200ResponseItemsInnerAllergensInner
 */
export interface GetProducts200ResponseItemsInnerAllergensInner {
}

/**
 * Check if a given object implements the GetProducts200ResponseItemsInnerAllergensInner interface.
 */
export function instanceOfGetProducts200ResponseItemsInnerAllergensInner(value: object): value is GetProducts200ResponseItemsInnerAllergensInner {
    return true;
}

export function GetProducts200ResponseItemsInnerAllergensInnerFromJSON(json: any): GetProducts200ResponseItemsInnerAllergensInner {
    return GetProducts200ResponseItemsInnerAllergensInnerFromJSONTyped(json, false);
}

export function GetProducts200ResponseItemsInnerAllergensInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetProducts200ResponseItemsInnerAllergensInner {
    return json;
}

export function GetProducts200ResponseItemsInnerAllergensInnerToJSON(json: any): GetProducts200ResponseItemsInnerAllergensInner {
    return GetProducts200ResponseItemsInnerAllergensInnerToJSONTyped(json, false);
}

export function GetProducts200ResponseItemsInnerAllergensInnerToJSONTyped(value?: GetProducts200ResponseItemsInnerAllergensInner | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

